module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-1-en-GB-deaac3e5f2332847aa4245808298dd23.png";